import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { useEffect, useState } from "react";
import { api } from "../lib/api";

const TERMS = [
  "All ads are subject to review and approval within 24 hours of payment.",
  "IslandsDaily reserves the right to reject any ad that violates our content guidelines, is misleading, offensive, or inappropriate for our audience.",
  "Ads for illegal products or services will not be accepted.",
  "Payment is required before ad activation. Approved ads go live on the selected start date.",
  "No refunds after ad activation. If an ad is rejected before activation, full refund will be processed within 5 business days.",
  "Advertisers are responsible for ensuring their ad content and destination URL comply with all applicable laws.",
  "IslandsDaily may remove any ad at any time if it receives complaints or is found to violate these terms.",
];

export default function AdvertiseTermsPage() {
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    document.title = "Advertising Terms — IslandsDaily";
    api.get("/advertise/enabled").then((r) => {
      if (!r.data?.enabled) setNotFound(true);
    }).catch(() => setNotFound(true));
  }, []);
  if (notFound) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="terms-404">
        <div className="text-center">
          <h1 className="font-serif-display text-3xl text-[#1A2E35]">404</h1>
          <Link to="/" className="text-[#0AADA0] mt-4 inline-block">← Home</Link>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-white" data-testid="advertise-terms-page">
      <Header />
      <main className="max-w-3xl mx-auto py-12 px-4">
        <h1 className="font-serif-display text-[#1A2E35] text-3xl mb-6">
          IslandsDaily Advertising Terms
        </h1>
        <ol className="space-y-3 text-[14px] text-[#1A2E35] list-decimal pl-6">
          {TERMS.map((t, i) => <li key={i}>{t}</li>)}
        </ol>
        <p className="text-[13px] text-[#6B7C82] mt-8">
          For questions contact <a href="mailto:hello@islandsdaily.com" className="text-[#0AADA0]">hello@islandsdaily.com</a>.
        </p>
        <div className="mt-8">
          <Link to="/advertise" className="text-[#0AADA0]">← Back to Advertise</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
